import React, { Component } from 'react';
import { observer } from 'mobx-react';
import AnimTipsWrapper from './anim-tips-wrapper';
import styles from './anim-tips-wrapper.css';
import type { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type EditingStateManager from '@src/slide/application/service/editing-state-manager';

interface Props {
    slide?: ISlideModel;
    scale: number;
    editingStateManager: EditingStateManager;
}

@observer
class AnimTips extends Component<Props> {
    public render(): JSX.Element | null {
        if (!this.props.slide) return null;
        return <div className={styles.wrapper}>{this.props.slide.children?.map(this.renderElement)}</div>;
    }

    private renderElement = (childObj: IElementBaseModel) => {
        if (childObj.animList.length > 0) {
            return (
                <AnimTipsWrapper
                    key={childObj.key}
                    scale={this.props.scale}
                    element={childObj}
                    editingStateManager={this.props.editingStateManager}
                />
            );
        }
        return null;
    };
}

export default AnimTips;
